import { t } from '@lingui/core/macro';
import type { CarNotificationDefaultRecord } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiCard } from 'noddi-ui-web';
import { formatPhoneNumber, getUserDisplayName } from 'noddi-util';

interface Props {
  carManagers: CarNotificationDefaultRecord[];
}

export const CarManagersInfo = ({ carManagers }: Props) => {
  if (carManagers.length === 0) {
    return null;
  }

  return (
    <NoddiCard
      title={t`Drivers`}
      description={t`The registered drivers for this car will receive a booking confirmation and reminder SMS.`}
    >
      <div className='flex flex-col gap-2'>
        {carManagers.map((manager) => (
          <div key={manager.userId} className='flex items-center gap-2'>
            <NoddiIcon name='User' size='small' />
            <span className='text-sm'>{getUserDisplayName(manager)}</span>
            {manager.phoneNumber && (
              <span className='text-sm text-muted-foreground'>{formatPhoneNumber(manager.phoneNumber)}</span>
            )}
          </div>
        ))}
      </div>
    </NoddiCard>
  );
};
